export const getSecretValues = `query SecretValues($input: SecretValuesInput){
  SecretValues(input: $input) {
    secrets
  }
}`